import { render, staticRenderFns } from "./ShopsTable.vue?vue&type=template&id=18256c74&scoped=true"
import script from "./ShopsTable.vue?vue&type=script&lang=js"
export * from "./ShopsTable.vue?vue&type=script&lang=js"
import style0 from "./ShopsTable.vue?vue&type=style&index=0&id=18256c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18256c74",
  null
  
)

export default component.exports